<!-- OmniAidCircle.vue -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :aria-label="ariaLabel"
    role="img"
  >
    <mask
      :id="maskId"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="44"
      height="44"
    >
      <path
        d="M22.2917 43.8935C10.4366 43.8935 0.793701 34.2506 0.793701 22.3955C0.793701 10.5403 10.4366 0.897461 22.2917 0.897461C34.1469 0.897461 43.7897 10.5403 43.7897 22.3955C43.7897 34.2506 34.1469 43.8935 22.2917 43.8935ZM9.8314 35.8181C12.5397 38.3082 17.004 40.8875 21.8056 40.8875C22.7481 40.8875 23.6806 40.7883 24.5735 40.5899C27.5397 39.9252 31.2302 37.8816 32.7977 34.826C33.7897 32.8816 33.8592 30.7288 33.006 28.4272C29.3651 33.2288 22.2719 36.3141 14.752 36.3141C13.0358 36.3141 11.379 36.1554 9.8314 35.828V35.8181ZM34.9802 25.1633C36.3989 28.1594 37.0536 31.0562 35.7342 35.0344C40.0695 30.2328 42.5794 22.3756 38.8691 14.5582C34.9604 6.32405 27.381 4.53833 23.4326 4.19111C28.3334 5.76849 32.2322 8.74468 34.5635 12.7427C36.7262 16.5919 36.8751 20.9967 34.9802 25.1733V25.1633ZM6.53775 31.7308C8.631 32.207 10.754 32.455 12.8473 32.455C20.4663 32.455 27.4306 29.1812 30.6846 24.0919C28.2838 21.3935 23.9881 18.1594 16.9445 17.6633C16.5675 17.6336 16.1905 17.6237 15.8135 17.6237C10.883 17.6237 6.35918 19.9352 3.9683 21.9391C3.88894 25.3717 4.77188 28.7546 6.53775 31.7308ZM16.6866 14.3697C22.4008 14.3697 27.9663 16.8102 32.0139 21.076C32.7778 18.7645 32.1627 15.5106 30.377 12.6038C27.8076 8.4173 23.5715 5.84786 18.7699 5.57008C18.5417 5.56016 18.3235 5.55024 18.1052 5.55024C10.4862 5.55024 5.63497 13.0403 4.34529 18.834C7.72823 15.9471 12.0735 14.3697 16.6866 14.3697Z"
        fill="white"
      />
    </mask>
    <g :mask="`url(#${maskId})`">
      <path
        d="M30.9424 61.4726C51.549 61.4726 68.2539 44.7677 68.2539 24.1611C68.2539 3.55454 51.549 -13.1504 30.9424 -13.1504C10.3358 -13.1504 -6.36914 3.55454 -6.36914 24.1611C-6.36914 44.7677 10.3358 61.4726 30.9424 61.4726Z"
        :fill="`url(#${gradId})`"
      />
    </g>
    <defs>
      <radialGradient
        :id="gradId"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(30.9424 24.1611) scale(37.3115)"
      >
        <stop offset="0.04" stop-color="#0084FF" />
        <stop offset="0.76" stop-color="#B1E4FC" />
        <stop offset="0.91" stop-color="#D6F8FC" />
      </radialGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  /** width/height in px (number or CSS size like "2rem") */
  size: {
    type: [Number, String],
    default: 44,
  },
  /** prefix to ensure unique IDs if multiple instances on page */
  idPrefix: {
    type: String,
    default: "oa",
  },
  /** accessible label */
  ariaLabel: {
    type: String,
    default: "OmniAid circle logo",
  },
});

const uid = Math.random().toString(36).slice(2);
const base = `${props.idPrefix}-${uid}`;
const maskId = computed(() => `${base}-mask`);
const gradId = computed(() => `${base}-grad`);
</script>
